import { CreatorClustersProvider } from 'contexts/CreatorClustersContext'

import { useCreatorClustersWrapperModel } from './creator-clusters-wrapper.model'
import type { ICreatorClustersWrapperProps } from './creator-clusters-wrapper.types'
import { CreatorClustersWrapperView } from './creator-clusters-wrapper.view'

function CreatorClustersWrapperBridge({ children, ClusterPage }: ICreatorClustersWrapperProps) {
  const { isLoading, showClusterPage } = useCreatorClustersWrapperModel()

  return (
    <CreatorClustersWrapperView isLoading={isLoading} showClusterPage={showClusterPage} ClusterPage={ClusterPage}>
      {children}
    </CreatorClustersWrapperView>
  )
}

export function CreatorClustersWrapper({ children, ClusterPage }: ICreatorClustersWrapperProps) {
  return (
    <CreatorClustersProvider>
      <CreatorClustersWrapperBridge ClusterPage={ClusterPage}>{children}</CreatorClustersWrapperBridge>
    </CreatorClustersProvider>
  )
}
